import { createSlice } from "@reduxjs/toolkit";
import { connectSocket, getSocket } from "../services/socket"; // Asegúrate de que la ruta sea correcta

// Estado inicial con usuario autenticado desde localStorage
let parsedUser = null;
let parsedEmpresas = null;

try {
  const storedUser = localStorage.getItem("user");
  parsedUser = storedUser ? JSON.parse(storedUser) : null;

  const storedEmpresas = localStorage.getItem("empresas");
  parsedEmpresas = storedEmpresas ? JSON.parse(storedEmpresas) : null;

  if (parsedUser && !getSocket()) {
    const token = localStorage.getItem("token");
    connectSocket(token);
  }
} catch (error) {
  console.warn("⚠️ Error al parsear datos del localStorage:", error);
}

const initialState = {
  user: parsedUser,
  token: localStorage.getItem("token") || null,
  empresas: parsedEmpresas,
  empresaSeleccionada: parsedEmpresas?.[0] || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.empresas = action.payload.empresas;
      state.empresaSeleccionada = action.payload.empresas?.[0] || null;
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("empresas", JSON.stringify(action.payload.empresas));
      localStorage.setItem("empresaSeleccionada", JSON.stringify(state.empresaSeleccionada));
      connectSocket(action.payload.token);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.empresas = null;
      state.empresaSeleccionada = null;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("empresas");
      localStorage.removeItem("empresaSeleccionada");
    },
    seleccionarEmpresa: (state, action) => {
      const id_empresa = action.payload;
      const empresa = state.empresas?.find((e) => e.id === id_empresa) || null;
      state.empresaSeleccionada = empresa;
      localStorage.setItem("empresaSeleccionada", JSON.stringify(empresa));
    },
  },
});

export const { login, logout, seleccionarEmpresa } = authSlice.actions;
export default authSlice.reducer;
